// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Vc26M","cancelButton":"uz_tF"};